const PREFIX = "lumen_privacy_review_snooze";
export const DEFAULT_PRIVACY_REVIEW_SNOOZE_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

export const privacyReviewSnoozeKey = (parentId?: string | number | null) =>
  `${PREFIX}:${parentId ?? "current"}`;

export const isPrivacyReviewSnoozed = (
  parentId?: string | number | null,
  now = Date.now(),
  storage: Pick<Storage, "getItem"> | null = typeof window === "undefined" ? null : window.localStorage
) => {
  if (!storage) return false;
  const until = Number(storage.getItem(privacyReviewSnoozeKey(parentId)));
  return Number.isFinite(until) && until > now;
};

export const snoozePrivacyReview = (
  parentId?: string | number | null,
  days: unknown = DEFAULT_PRIVACY_REVIEW_SNOOZE_DAYS,
  now = Date.now(),
  storage: Pick<Storage, "setItem"> | null = typeof window === "undefined" ? null : window.localStorage
) => {
  // School setting privacyReviewSnoozeDays; anything unusable falls back to the default.
  const snoozeDays = Number.isInteger(days) && (days as number) > 0 ? (days as number) : DEFAULT_PRIVACY_REVIEW_SNOOZE_DAYS;
  storage?.setItem(privacyReviewSnoozeKey(parentId), String(now + snoozeDays * DAY_MS));
};

export const clearPrivacyReviewSnooze = (
  parentId?: string | number | null,
  storage: Pick<Storage, "removeItem"> | null = typeof window === "undefined" ? null : window.localStorage
) => storage?.removeItem(privacyReviewSnoozeKey(parentId));
